import { Modal, Button } from 'react-bootstrap'

type FilePreviewModalProps = {
  src: string
  type: 'image' | 'pdf'
  onClose: () => void
  show: boolean
}

const FilePreviewModal = ({
  src,
  type,
  onClose,
  show,
}: FilePreviewModalProps) => {
  return (
    <Modal show={show} onHide={onClose} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center align-items-center">
        {type === 'image' ? (
          <img
            src={src}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
            }}
          />
        ) : (
          <iframe
            src={src}
            title="PDF Preview"
            style={{
              width: '100%',
              height: '80vh',
              border: 'none',
            }}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default FilePreviewModal
